__turbopack_context__.v({
  "actions": "WShopAdditionalSearchOptions-module__t0o4da__actions",
  "buttonPrimary": "WShopAdditionalSearchOptions-module__t0o4da__buttonPrimary",
  "buttonSecondary": "WShopAdditionalSearchOptions-module__t0o4da__buttonSecondary",
  "chip": "WShopAdditionalSearchOptions-module__t0o4da__chip",
  "chipLabel": "WShopAdditionalSearchOptions-module__t0o4da__chipLabel",
  "chipRemove": "WShopAdditionalSearchOptions-module__t0o4da__chipRemove",
  "chips": "WShopAdditionalSearchOptions-module__t0o4da__chips",
  "chipsHeader": "WShopAdditionalSearchOptions-module__t0o4da__chipsHeader",
  "chipsLabel": "WShopAdditionalSearchOptions-module__t0o4da__chipsLabel",
  "chipsWrap": "WShopAdditionalSearchOptions-module__t0o4da__chipsWrap",
  "clearAllLink": "WShopAdditionalSearchOptions-module__t0o4da__clearAllLink",
  "empty": "WShopAdditionalSearchOptions-module__t0o4da__empty",
  "facetCount": "WShopAdditionalSearchOptions-module__t0o4da__facetCount",
  "facetItem": "WShopAdditionalSearchOptions-module__t0o4da__facetItem",
  "facetLabel": "WShopAdditionalSearchOptions-module__t0o4da__facetLabel",
  "facetList": "WShopAdditionalSearchOptions-module__t0o4da__facetList",
  "form": "WShopAdditionalSearchOptions-module__t0o4da__form",
  "priceInput": "WShopAdditionalSearchOptions-module__t0o4da__priceInput",
  "priceRow": "WShopAdditionalSearchOptions-module__t0o4da__priceRow",
  "root": "WShopAdditionalSearchOptions-module__t0o4da__root",
  "section": "WShopAdditionalSearchOptions-module__t0o4da__section",
  "sectionTitle": "WShopAdditionalSearchOptions-module__t0o4da__sectionTitle",
  "title": "WShopAdditionalSearchOptions-module__t0o4da__title",
  "variantGroup": "WShopAdditionalSearchOptions-module__t0o4da__variantGroup",
  "variantGroupName": "WShopAdditionalSearchOptions-module__t0o4da__variantGroupName",
  "variantGroups": "WShopAdditionalSearchOptions-module__t0o4da__variantGroups",
});
